import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import StickyCTA from './StickyCTA';
import ScrollToTop from './ScrollToTop';
import { ScrollProgress } from './effects';

const Layout = ({ children }) => {
  return (
    <div className="App bg-brand-ink min-h-screen">
      <ScrollToTop />
      <ScrollProgress />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
      <StickyCTA />
    </div>
  );
};

export default Layout;
